<template>
  <div v-if="route">
    <template v-if="!route.children || route.children.length === 0">
      <el-menu-item :index="route.key">{{ route.label }}</el-menu-item>
    </template>
    <el-submenu v-else :index="route.key">
      <template slot="title">
        <span class="submenu-title">{{ route.label }}</span>
      </template>
      <sub-menu v-for="child in route.children" :key="child.key" :route="child"></sub-menu>
    </el-submenu>
  </div>
</template>

<script setup>
import { ref } from 'vue'

// eslint-disable-next-line
defineProps({
  route: {
    type: Object
  }
})

function hasOneShowingChild(children = [], parent) {
  if (children.length === 1) {
    return true
  }
  if (children.length === 0) {
    return true
  }
  return false
}
</script>

<script>
export default {
  name: 'SubMenu'
}
</script>

<style lang="scss" scoped>
::v-deep .el-submenu__title {
  height: 42px !important;
  line-height: 42px !important;
}
::v-deep .el-menu-item {
  height: 42px !important;
  line-height: 42px !important;
}
.submenu-title {
  font-weight: 700;
}
</style>
